module.exports = __webpack_public_path__ + "img/Kebab.6e87f978.png";